import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { InputMaskModule } from '@ngneat/input-mask';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SimpleModalComponent } from './modal/modals/simple-modal/simple-modal.component';
import { ErrorModalComponent } from './modal/modals/error-modal/error-modal.component';
import { SvgIconComponent } from './svg-icon/svg-icon.component';
import { ButtonComponent } from './button/button.component';
import { ProgressMeterComponent } from './progress-meter/progress-meter.component';
import { InputComponent } from './input/input.component';
import { FileInputComponent } from './file-input/file-input.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { ProgressSpinnerComponent } from './progress-spinner/progress-spinner.component';
import { MaskPipe } from './mask-pipe/mask.pipe';
import { TextareaComponent } from './textarea/textarea.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { SelectComponent } from './select/select.component';
import { WysiwygComponent } from './wysiwyg/wysiwyg.component';
import { WysiwygPipe } from './wysiwyg/wysiwyg-pipe/wysiwyg.pipe';
import { RadioInputComponent } from './radio-input/radio-input.component';
import { VideoPreviewComponent } from './video-preview/video-preview.component';
import { ImageGalleryModule } from './image-gallery/image-gallery.module';
import { CheckboxInputComponent } from './checkbox-input/checkbox-input.component';
import { DatesCarouselComponent } from './dates-carousel/dates-carousel.component';
import { SimpleExpandComponent } from './simple-expand/simple-expand.component';
import { ImageCroppingComponent } from './image-cropping/image-cropping.component';
import { IMAGE_CROPPING_GLOBAL_CONFIG } from './image-cropping/image-cropping.config';
import { RemovalModalComponent } from './modal/modals/removal-modal/removal-modal.component';
import { PreviewModalComponent } from './modal/modals/preview-modal/preview-modal.component';
import { YouTubeVideoModalComponent } from './modal/modals/youtube-video-modal/youtube-video-modal.component';
import { ErrorIncorrectStatusModalComponent } from './modal/modals/error-incorrect-status-modal/error-incorrect-status-modal.component';
import { StatusDescriptionModalComponent } from './modal/modals/status-description-modal/status-description-modal.component';
import { IconComponent } from './icon/icon.component';
import { IconTileComponent } from './icon-tile/icon-tile.component';
import { UniversalErrorModalComponent } from './modal/modals/universal-error-modal/universal-error-modal.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    InputMaskModule,
    FormsModule,
    MatDialogModule,
    MatSelectModule,
    PdfViewerModule,
    MatRadioModule,
    YouTubePlayerModule,
    ImageGalleryModule,
    MatCheckboxModule,
  ],
  declarations: [
    SvgIconComponent,
    ButtonComponent,
    ProgressMeterComponent,
    InputComponent,
    FileInputComponent,
    DatePickerComponent,
    ProgressSpinnerComponent,
    MaskPipe,
    SimpleModalComponent,
    TextareaComponent,
    SearchInputComponent,
    SelectComponent,
    ErrorModalComponent,
    RemovalModalComponent,
    PreviewModalComponent,
    WysiwygComponent,
    WysiwygPipe,
    RadioInputComponent,
    YouTubeVideoModalComponent,
    VideoPreviewComponent,
    ErrorIncorrectStatusModalComponent,
    StatusDescriptionModalComponent,
    CheckboxInputComponent,
    DatesCarouselComponent,
    SimpleExpandComponent,
    ImageCroppingComponent,
    IconComponent,
    IconTileComponent,
    UniversalErrorModalComponent,
  ],
  exports: [
    SvgIconComponent,
    ButtonComponent,
    ProgressMeterComponent,
    InputComponent,
    FileInputComponent,
    DatePickerComponent,
    ProgressSpinnerComponent,
    MaskPipe,
    SimpleModalComponent,
    TextareaComponent,
    SearchInputComponent,
    SelectComponent,
    ErrorModalComponent,
    RemovalModalComponent,
    PreviewModalComponent,
    WysiwygComponent,
    RadioInputComponent,
    YouTubeVideoModalComponent,
    StatusDescriptionModalComponent,
    VideoPreviewComponent,
    ImageGalleryModule,
    CheckboxInputComponent,
    DatesCarouselComponent,
    SimpleExpandComponent,
    ImageCroppingComponent,
    IconComponent,
    IconTileComponent,
    UniversalErrorModalComponent,
  ],
  providers: [
    {
      provide: IMAGE_CROPPING_GLOBAL_CONFIG,
      useValue: { croppedWidthPX: 600, croppedHeightPX: 750 },
    },
  ],
})
export class SharedUiModule {}
